import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import { IconButton, Stack, Box, Tooltip, Typography } from "@mui/material";

import "./StuInfoComp/studentcard.scss";

// src
import { AuthContext } from "../../../Context/AuthContext";
import { translateLauguage } from "../../../Function/Translate";

import StudentCard from "./StuInfoComp/StudentCard";
import moment from "moment";

export default function StudentInformation({ tableData }) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 3.5 }}>
        <StudentCard tableData={tableData} />
      </Grid>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 8.5 }}
        className="student-info-container"
      >
        <Stack direction="column">
          <Stack sx={{ marginBottom: "15px" }}>
            <Typography
              className={language === "en" ? "title-en-stu" : "title-kh-stu "}
            >
              {t("personal_info")}
            </Typography>
          </Stack>
          {/* {tableData?.map((e, index) => {
            return ( */}
          <Stack direction="column" spacing={2}>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>{t("thead_student_id")}</Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{tableData?.student_id}</Typography>
            </Stack>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>{t("thead_student_name")}</Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{tableData?.full_name_kh}</Typography>
            </Stack>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>
                {t("student_latin_name")}
              </Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{tableData?.full_name_latin}</Typography>
            </Stack>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>{t("thead_gender")}</Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{tableData?.gender}</Typography>
            </Stack>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>{t("dob")}</Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{moment(tableData?.date_of_birth)?.format("DD-MM-YYYY")}</Typography>
            </Stack>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>{t("label_tel")}</Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{tableData?.phone_number}</Typography>
            </Stack>
            <Stack direction="row">
              <Typography sx={{ width: "25%" }}>{t("current_address")}</Typography>
              <Typography sx={{ width: "5%" }}>:</Typography>
              <Typography>{tableData?.current_address}</Typography>
            </Stack>
          </Stack>
          {/* );
          })} */}
        </Stack>
      </Grid>
    </Grid>
  );
}
